/**
 * permission Group
 * @param fb : FormBuilder
 */
export function permissionGroup (fb: any) {
    fb.group({
        booking: fb.group([
            fb.group({
                create: ['']
            })
        ])
    })
}
